import type { JSX } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: 8,
  padding: '4px 8px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  boxSizing: 'border-box',
  height: 'auto',
  minHeight: 'unset',
  width: 'auto',
  maxWidth: '100%',
  minWidth: 0,
  flex: '0 0 auto',
  alignSelf: 'flex-start',
  color: '#FFFFFF',
  backgroundColor: theme.palette.primary.main,

  '&.MuiChip-colorError': {
    backgroundColor: theme.palette.error.main
  },

  '&:hover': {
    backgroundColor: theme.palette.primary.dark
  },

  '&.MuiChip-colorError:hover': {
    backgroundColor: theme.palette.error.dark
  },

  '& .MuiChip-label': {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    font: 'var(--sprout-font-body1)',
    lineHeight: '18px',
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  '& .MuiChip-icon, & .MuiChip-deleteIcon': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    minWidth: 24,
    minHeight: 24,
    margin: 0,
    color: '#FFFFFF',
    lineHeight: 0
  },

  '& .MuiChip-icon .MuiSvgIcon-root, & .MuiChip-icon svg': {
    width: 20,
    height: 20,
    fontSize: 20
  },

  '& .MuiChip-deleteIcon': {
    transform: 'scale(0.9)',
    transformOrigin: 'center'
  }
}));


interface TagProps {
  label: string;
  handleRemove?: (label: string) => void;
  hasError?: boolean;
}


const Tag = ({
  label,
  handleRemove,
  hasError = false
}: TagProps): JSX.Element => {
  const onDelete = handleRemove
    ? () => handleRemove(label)
    : undefined;

  return (
    <StyledChip
      label={label}
      onDelete={onDelete}
      icon={
        hasError ? (
          <ErrorOutlineIcon fontSize="small" />
        ) : undefined
      }
      variant="filled"
      color={hasError ? 'error' : 'primary'}
      size="medium"
    />
  );
};

export default Tag;